export { default } from "./Picture";
